import React, { FunctionComponent } from 'react';
import {
  AdditionalPrice,
  AdditionalPriceLabel,
  BasePrice,
  BasePriceLabel,
  Row,
} from './PriceDetails.style';
import { useGetPackageData } from '../../hooks';

type Props = {
  netPrice: number;
  additionalFees: number;
};

export const PriceDetails: FunctionComponent<Props> = ({ netPrice, additionalFees }) => {
  const { packageData } = useGetPackageData();
  return (
    <div>
      <Row>
        <BasePriceLabel>
          {packageData?.search_type === 'hotel'
            ? 'Базовая стоимость отеля'
            : 'Базовая стоимость тура'}
        </BasePriceLabel>
        <BasePrice value={netPrice} />
      </Row>
      <Row>
        <AdditionalPriceLabel>Доплаты и сборы</AdditionalPriceLabel>
        <AdditionalPrice prefix={'+'} value={additionalFees} />
      </Row>
    </div>
  );
};
